import { useState, useEffect, useRef } from 'react';
import { $t } from 'hooks/i18n';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';

import ExcelUploader from './ExcelUploader';
import DataTableComponent from './DataTableComponent';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import axios from 'axios'
export default function UploadexcelPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const API_BASE_URL = `${process.env.REACT_APP_API_PATH}`;
const [records, setRecords] = useState([]);
const [loading, setLoading] = useState(false);
const [totalRecords, setTotalRecords] = useState(0);
const [showUploadDialog, setShowUploadDialog] = useState(false);
const toast = useRef(null);
const fetchRecords = async (page = 1, rows = 20) => {
    setLoading(true);
    try {
        const response =await axios.get(`${API_BASE_URL}excelimport/records`, {
        params: { page, pageSize: rows }
    });
    if (response.data.success) {
        setRecords(response.data.data);
        setTotalRecords(response.data.totalCount);
        setCurrentPage(page);
        } else {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: response.data.message || 'Failed to fetch records',
            life: 3000
        });
    }
    } catch (error) {
    console.error('Error fetching records:', error);
    toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch records',
        life: 3000
    });
    } finally {
    setLoading(false);
}
};
const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
        const response = await axios.post(`${API_BASE_URL}excelImport/import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    if (response.data.success) {
        toast.current.show({
            severity: 'success',
            summary: 'Import Successful',
            detail: `${response.data.savedRecords} records imported successfully`,
            life: 5000
        });
        setShowUploadDialog(false);
        fetchRecords(1);
        } else {
        toast.current.show({
            severity: 'error',
            summary: 'Import Failed',
            detail: response.data.message,
            life: 5000
        });
        if (response.data.errors && response.data.errors.length > 0) {
            console.error('Errors:', response.data.errors);
        }
    }
    } catch (error) {
    console.error('Error uploading file:', error);
    toast.current.show({
        severity: 'error',
        summary: 'Upload Failed',
        detail: error.response?.data?.message || 'Failed to upload file',
        life: 5000
    });
    throw error;
}
};
const confirmClearAll = () => {
    confirmDialog({
        message: 'Are you sure you want to clear all records? This action cannot be undone.',
        header: 'Clear All Records',
        icon: 'pi pi-exclamation-triangle',
        acceptClassName: 'p-button-danger',
        accept: async () => {
            setLoading(true);
            try {
                const response = await axios.delete(`${API_BASE_URL}excelimport/clear`);
                if (response.data.success) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: response.data.message,
                        life: 3000
                    });
                    fetchRecords(1);
                    } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                } catch (error) {
                console.error('Error clearing records:', error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to clear records',
                    life: 3000
                });
                } finally {
                setLoading(false);
            }
        }
    });
};
const confirmDeleteRecord = (loanId) => {
    confirmDialog({
        message: `Are you sure you want to delete record with Loan ID: ${loanId}?`,
        header: 'Delete Record',
        icon: 'pi pi-trash',
        acceptClassName: 'p-button-danger',
        accept: async () => {
            setLoading(true);
            try {
                const response = await axios.delete(`${API_BASE_URL}excelimport/record/${loanId}`);
                if (response.data.success) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: response.data.message,
                        life: 3000
                    });
                    fetchRecords(currentPage);
                    } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                } catch (error) {
                console.error('Error deleting record:', error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to delete record',
                    life: 3000
                });
                } finally {
                setLoading(false);
            }
        }
    });
};
useEffect(() => {
    fetchRecords();
}, []);
const renderHeader = () => {
    return (
    <div className="sticky-header">
    <div className="header-content">
    <div>
    <div className="flex justify-content-between align-items-center">
    <div>
    <h1 className="text-2xl font-bold text-primary m-0">Excel Data Import System</h1>
    <p className="text-600 mt-2">Upload Excel files to import customer data</p>
    </div>
    <div className="flex gap-2">
    <Badge value={`Total: ${totalRecords}`} severity="info" className="mr-2"></Badge>
    <Button
    label="Import Excel"
    icon="pi pi-upload"
    className="p-button-primary"
    onClick={() => setShowUploadDialog(true)}
    disabled={loading}
    />
    <Button
    label="Clear All"
    icon="pi pi-trash"
    className="p-button-danger"
    onClick={confirmClearAll}
    disabled={loading || totalRecords === 0}
    />
    </div>
    </div>
    </div>
    </div>
    </div>
    );
};
	return (
		<main id="UploadexcelPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('uploadexcel')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="main-content-padding">
                        <div className="app">
                            <Toast ref={toast} />
                            <ConfirmDialog />
                            <div className="p-4">
                                <div className="card">
                                    {renderHeader()}
                                    <Dialog
                                        header="Import Excel File"
                                        visible={showUploadDialog}
                                        style={{ width: '600px' }}
                                        modal
                                        onHide={() => setShowUploadDialog(false)}
                                        closable={!loading}
                                        >
                                        <ExcelUploader onFileUpload={handleFileUpload} disabled={loading} />
                                    </Dialog>
                                    {loading && (
                                    <div className="flex justify-content-center align-items-center p-5">
                                        <ProgressSpinner />
                                    </div>
                                    )}
                                    {!loading && records.length > 0 && (
                                    <DataTableComponent
                                        records={records}
                                        onDelete={confirmDeleteRecord}
                                        />
                                        )}
                                        {!loading && records.length === 0 && (
                                        <div className="flex flex-column align-items-center justify-content-center p-5 mt-4">
                                            <i className="pi pi-database text-6xl text-400 mb-3"></i>
                                            <h3 className="text-600">No Records Found</h3>
                                            <p className="text-500">Click the "Import Excel" button to upload your first file.</p>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
		</main>
	);
}
